const populationDensityPolygons = populationDensity => {
	let polygons = {};
	for (let [ind, obj] of populationDensity.entries()) {
		let mLoc = {};
		ind = `density_${ind}`;
		mLoc.id = ind;

		let { population } = obj;

		mLoc.coordinates = obj.coordinates;
		mLoc.data = { population, weight: population };
		mLoc.marker = { position: obj.coordinates[0] };
		mLoc.showInfo = false;
		mLoc.style = {
			fillColor: "#FFFFFF11",
			strokeColor: "#00000000",
			zIndex: 11,
			strokeWeight: 3
		};

		polygons[ind] = mLoc;
	}

	return polygons;
};

const populationGridsPolygons = populationDensity => {
	let polygons = [];
	for (let [ind, obj] of populationDensity.entries()) {
		let color = !obj?.color.toString().includes("#") ? `#${obj?.color}` : obj?.color;
		polygons.push({
			id: ind,
			coordinates: obj.coordinates,
			style: {
				fillColor: color,
				strokeColor: "#00000055",
				zindex: 10
			},
			data: {
				index: ind
			},
			showInfo: false
		});
	}

	return polygons;
};

const dailyTrafficPolygons = dailytrafficData => {
	let polygons = [];
	for (let [ind, obj] of dailytrafficData.entries()) {
		let color = !obj?.color.toString().includes("#") ? `#${obj?.color}` : obj?.color;
		polygons.push({
			id: ind,
			coordinates: obj.coordinates,
			style: {
				fillColor: color,
				strokeColor: "#00000055",
				zindex: 10
			},
			data: {
				index: ind
			},
			showInfo: false
		});
	}

	return polygons;
};

const PopulationHeatMap = { populationDensityPolygons, populationGridsPolygons, dailyTrafficPolygons };
export default PopulationHeatMap;
